document.addEventListener('DOMContentLoaded', () => {
    const vidcontrol = document.querySelector('.headervisual-video-controls');
    const widgetVidcontrol = document.querySelectorAll('.widget-video-wrapper');
    if (vidcontrol) {
        const type = vidcontrol.dataset.type;
        const play = vidcontrol.querySelector('.play-video');
        const pause = vidcontrol.querySelector('.pause-video');
        const wrapper = vidcontrol.closest('.headervisual-wrapper');
        const video = wrapper.querySelector('.headervisual-video');

        const pauseVid = () => {
            if (type === 'youtube') {
                video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else {
                video.contentWindow.postMessage('{"method":"pause"}', '*');
            }
            pause.classList.remove('is-active');
            play.classList.add('is-active');
            wrapper.classList.add('is-paused');
        }

        const playVid = () => {
            if (type === 'youtube') {
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else {
                video.contentWindow.postMessage('{"method":"play"}', '*');
            }
            pause.classList.add('is-active');
            play.classList.remove('is-active');
            wrapper.classList.remove('is-paused');
        }

        pause.addEventListener('click', (e) => {
            e.preventDefault();
            pauseVid();
        });

        play.addEventListener('click', (e) => {
            e.preventDefault();
            playVid();
        });
    }

    widgetVidcontrol.forEach((vidcontrol) => {
        const type = vidcontrol.dataset.type;
        const play = vidcontrol.querySelector('.is-play');
        const preview = vidcontrol.querySelector('.widget-video-image');
        const video = vidcontrol.querySelector('.widget-video-video');

        vidcontrol.addEventListener('click', (e) => {
            e.preventDefault();
            preview.classList.remove('is-active');
            play.classList.remove('is-active');
            video.classList.add('is-active');
            if (type === 'youtube') video.setAttribute('src', video.dataset.src);
            setTimeout(() => {
                if (type === 'youtube') {
                    video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                } else {
                    video.contentWindow.postMessage('{"method":"play"}', '*');
                }
            }, 500);
        });
    });
});